import { palette } from '../palette';

const Styles = {
  masterContainer: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
  gridItem: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '10px',
  },
  card: {
    overflow: 'auto',
    width: '100%',
    margin: '0px',
    padding: '24px',
    gap: '24px',
    boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.05)',
    borderRadius: '18px',
  },
  cardContent: { padding: '0', paddingBottom: '0 !important' },
  title: {
    // fontSize: '16px',
    // fontStyle: 'normal',
    // fontWeight: '600',
    // lineHeight: '22px',
    // color: `${palette.disabled.dark}`,
  },
  inputLabel: {
    fontWeight: '400',
    fontSize: '1rem',
    lineHeight: '22px',
    // color: `${palette.disabled.dark}`,
    marginRight: '25px',
    whiteSpace: 'nowrap',
  },
  gridContainer: {
    marginTop: '12px',
    marginBottom: '12px',
    width: '100%',
  },
  masterPaperContainer: {
    margin: 'auto',
    boxShadow: '0px 0px 14px 0px #0000000D',
    borderRadius: '18px',
  },
  masterHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  masterSaveBtn: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '48px',
  },
  customChip: {
    borderRadius: '18px',
    padding: '0px 16px 0px 16px !important',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '21px',
  },
  totalCountCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0',
    padding: '0',
    gap: '20px',
    marginBottom: '20px',
  },
  tableTitle: {
    color: `${palette.disabled.dark}`,
    fontSize: '1.25rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    textWrap: 'nowrap'
  },
  icon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
    color: '#51648F',
  },
  cardHeader: {
    borderBottom: `1px solid ${palette.secondary.main}`,
    color: `${palette.disabled.dark}`,
    padding: '0px 0px 24px 0px',
  },
  select: { width: '100%', textAlign: 'left' },
};
export default Styles;
